import Vue from "vue";
import Vuex from "vuex";
import { getMediasIdsMap, mapById } from "../utils/collection.util";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

const store = new Vuex.Store({
    state: {
        menu: {},
        projects: {},
        contact: {},
        pages: {},
        partners: {},
        associates: {},
        references: {},
        jobOffers: {},
        team: {},
        galleries: {},
        videosLoadMap: {},
    },
    mutations: {
        init(state, payload) {
            state.menu = payload.menu;
            state.projects = mapById(payload.projects);
            state.sections = payload.sections;
            state.partners = payload.partners;
            state.associates = payload.associates;
            state.references = payload.references;
            state.galleries = payload.gallery;
            state.jobs = payload.jobs;
            state.team = payload.team;
            // state.contact = payload.contact

            state.videosLoadMap = getMediasIdsMap(payload.projects);
        },
        setMediaLoaded(state, mediaId) {
            state.videosLoadMap[mediaId] = true;
        },
    },
    actions: {
        setData({ commit }, payload) {
            commit("init", payload);
        },
    },
    strict: debug,
});

export default store;
export const useStore = () => store;
